<template>
  <v-row>
    <v-col cols="5" class="me-3">
      <p class="body3 mb-6 grey--text text--darken-1">
        {{ $t('problem_solving.problem_tool.description') }}
      </p>
      <div class="d-flex justify-center">
        <img :src="analysisToolImage" alt="analysis_tool" />
      </div>
    </v-col>
    <v-col data-tourid="problemSolving-5w2h-questions">
      <v-textarea
        data-private
        v-for="question in questions"
        v-model="question.answer"
        outlined
        dense
        hide-details
        class="mt-1 mb-5"
        rows="1"
        auto-grow
        no-resize
        maxlength="500"
        :disabled="!isEditMode"
        :data-tourid="`problemSolving-5w2h-${question.key}`"
        :key="question.key"
        :label="question.label"
        :placeholder="question.placeholder"
        @blur="trackEvent(question.key)"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import analysisToolImage from '@/assets/images/analysisTool.svg'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import { mapState } from 'vuex'

export default {
  name: 'Questions',

  mixins: [trackerMixin],

  props: {
    questions: {
      type: Array,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      analysisToolImage,
    }
  },

  computed: {
    ...mapState('problemSolving', {
      rev: ({ rev }) => rev,
    }),
  },

  methods: {
    trackEvent(changedField) {
      this.trackUpdate(this.rev, changedField)
    },
  },
}
</script>
